// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import React, { useEffect } from 'react';
import { featureIsEnabled } from '@ta/common.features';
import AddCta from './AddCta';
import EditCta from './EditCta';
import useExplicitPreferencesModal from './useExplicitPreferencesModal';
import useExplicitPreferencesDescription from './useExplicitPreferencesDescription';
import styles from './ExplicitPreferencesCta.css';

type Props = {|
  /**
   * A callback to reload the social feed after trip preferences have been edited
   */
  onRefresh: () => Promise<*>,
|};

/**
 * A button to start the Explicit Preferences flow for existing users
 */
const ExplicitPreferencesCta = ({ onRefresh }: Props) => {
  const { open, isEnabled, state } = useExplicitPreferencesModal('EDITING', onRefresh);
  const description = useExplicitPreferencesDescription(state);

  // Open the flow automatically when linked to the appropriate hash. This is to support deep
  // linking into the flow from CRM.
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    if (isEnabled && window.location.hash.toLowerCase() === '#onboarding') {
      open();
    }
  }, [isEnabled, open]);

  if (!isEnabled) {
    return null;
  }

  if (!(description || featureIsEnabled('cx_explicit_preferences_scoped_home_cta'))) {
    return null;
  }

  return (
    <>
      {/* The #preferences fragment is used to deep link directly to the top of the feed
        after onboarding */}
      <div id="preferences" className={styles.fragment} />

      {description != null ? (
        <EditCta description={description} onClick={open} />
      ) : (
        <AddCta onClick={open} />
      )}
    </>
  );
};

export default ExplicitPreferencesCta;
